module.exports = __webpack_public_path__ + "static/assets/01fc0da0b4f9dfcf62ee83e1505e14f2.png";